"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _theme = require("../../style/theme");

var _templateObject, _templateObject2;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Menu = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  -webkit-tap-highlight-color: transparent;\n  width: 60px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n\n  > span {\n    display: block;\n    width: 30px;\n    height: 3px;\n    background: ", ";\n    margin-bottom: 6px;\n    border-radius: 3px;\n    transition: 0.2s ease-in-out;\n    transform-origin: left;\n\n    ", "\n\n    :last-child {\n      margin-bottom: 0;\n    }\n  }\n"])), (0, _theme.th)('colors.white'), function (_ref) {
  var isOpen = _ref.isOpen;
  return isOpen && (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        :nth-child(1) {\n          transform: rotate(45deg) translate(2px, -4px);\n        }\n        :nth-child(2) {\n          opacity: 0;\n        }\n        :nth-child(3) {\n          transform: rotate(-45deg) translate(2px, 4px);\n        }\n      "])));
});

var Hamburger = function Hamburger(_ref2) {
  var onClick = _ref2.onClick,
      isOpen = _ref2.isOpen;
  return /*#__PURE__*/_react.default.createElement(Menu, {
    onClick: onClick,
    isOpen: isOpen
  }, /*#__PURE__*/_react.default.createElement("span", null), /*#__PURE__*/_react.default.createElement("span", null), /*#__PURE__*/_react.default.createElement("span", null));
};

Hamburger.propTypes = {
  onClick: _propTypes.default.func,
  isOpen: _propTypes.default.bool
};
var _default = Hamburger;
exports.default = _default;